import http from '@/config/api';
import router from '@/router';

export default {
  async searchCoupon({ commit }, payload) {
    const directory = payload?.directory || router.currentRoute.value?.params.directory;
    const response = await http
      .get('/shops/coupons?', {
        params: {
          ...payload.query,
          directory,
          offset: payload.offset,
          limit: payload.limit,
        },
        isLoading: true,
      })
      .then((res) => {
        if (payload?.isWithoutLoadmore) {
          commit('SET_COUPON_LIST', res?.data);
        } else {
          commit('ADD_COUPON_LIST', res?.data);
        }
        return res?.data;
      });
    return response;
  },
  async resetState({ commit }) {
    commit('RESET_STATE');
  },
};
